module.exports = __webpack_public_path__ + "static/media/Bucuresti.ca54dbd1.jpg";